import { Grid, useMediaQuery } from '@mui/material';
import { Outlet, useLocation } from 'react-router-dom';
import SideNavigationPanel from '../../GlobalComponent/SideNavigationPanel/SideNavigationPanel';
import GlobalNavbar from '../../GlobalComponent/GlobalNavbar/GlobalNavbar';
import globalStyles from '../../Styles/ComponentStyles/global.module.scss';
import GLobalFooter from '../../GlobalComponent/GlobalFooter/GLobalFooter';
import { useContext } from 'react';
import { ProfileContext, ProfileContextPayload } from '../../Context/ProfileDetailsContext';
import { AgentContext, AgentContextPayload } from '../../Context/AgentDetailsContext';
import { TrainingContext, TrainingContextPayload } from '../../Context/TrainingPageContext';

const MainComponent = () => {
    const isBelow768 = useMediaQuery('(min-width:769px)');
    const location = useLocation();

    const {
        setFlagOpenRegisterProfileDialog,
    } = useContext(ProfileContext) as ProfileContextPayload;

    const {
        setIsEditMode,
        setFlagOpenAgentDetailsDialog,
        setagentFormDetails
    } = useContext(AgentContext) as AgentContextPayload;

    const {
        setFlagOpenAddNewResourceDialog,
        setSelectedResorceData,
        setIsEditModeTrainingPage,
    } = useContext(TrainingContext) as TrainingContextPayload;

    const routesWithoutNavbar = [
        '/iulProfileDetails',
        'newprofile',
        '/annuityProfileDetails',
        // Add more routes as needed
    ];

    // Check if current route should hide navbar
    const shouldHideNavbar = () => {
        const path = location.pathname.toLowerCase();
        return routesWithoutNavbar.some(route => path.includes(route.toLowerCase()));
    };

    // Define navbar configuration based on current route
    const getNavbarConfig = () => {
        if (shouldHideNavbar()) {
            return null;
        }

        const path = location.pathname.toLowerCase();

        if (path.startsWith('/profile')) {
            return {
                navbarBtnText: "New Profile",
                navbarText: "Profiles",
                navbarBtnOnClick: () => {
                    setFlagOpenRegisterProfileDialog(true);
                }
            };
        }

        if (path.startsWith('/dashboard')) {
            return {
                navbarBtnText: "",
                navbarText: "Dashboard",
                flagBorderBottom: true
            };
        }

        if (path.startsWith('/agent')) {
            return {
                navbarBtnText: "New Agent",
                navbarText: "Agents List",
                navbarBtnOnClick: () => {
                    setIsEditMode(false)
                    setFlagOpenAgentDetailsDialog(true)
                    setagentFormDetails({})
                },
                flagBorderBottom: true
            };
        }

        if (path.startsWith('/pending-requests')) {
            return {
                navbarBtnText: "",
                navbarText: "Pending Requests",
                flagBorderBottom: true
            };
        }

        if (path.startsWith('/spenddowncalc')) {
            return {
                navbarBtnText: "",
                navbarText: "Spend Down Calculator",
                flagBorderBottom: true
            };
        }

        if (path.startsWith('/training')) {
            return {
                navbarBtnText: "Add New",
                navbarText: "Training",
                navbarBtnOnClick: () => {
                    setFlagOpenAddNewResourceDialog(true);
                    setSelectedResorceData({});
                    setIsEditModeTrainingPage(false)
                }
            };
        }

        if (path.startsWith('/inflationcalculator')) {
            return {
                navbarBtnText: "",
                navbarText: "Inflation Calculator",
                flagBorderBottom: true
            };
        }

        if (path.startsWith('/myaccount')) {
            return {
                navbarBtnText: "",
                navbarText: "My Account",
                flagBorderBottom: true
            };
        }

        if (path.startsWith('/super-admin-dashboard')) {
            return {
                navbarBtnText: "",
                navbarText: "Super Admin Dashboard",
                flagBorderBottom: true
            };
        }

        // Default navbar config for other routes (optional)
        return {
            navbarBtnText: "",
            navbarText: "",
            navbarBtnOnClick: () => { }
        };
    };

    const navbarConfig = getNavbarConfig();

    return (
        <>
            <Grid container>
                <Grid item xs={12}>
                    <Grid
                        container
                        direction="row"
                        className={globalStyles.mainContainer}
                        style={{
                            height: '100vh',
                            display: 'flex',
                            flexDirection: 'column',
                        }}
                    >
                        <Grid
                            item
                            style={{
                                flexGrow: 1,
                                display: 'flex',
                                overflow: 'hidden', // Prevent outer container from scrolling
                            }}
                            xs={12}
                        >
                            <Grid container flexWrap={"nowrap"} height="100%">
                                <Grid
                                    item
                                    sx={{
                                        flexShrink: 0,
                                        zIndex: 10,
                                        overflowY: 'auto',
                                    }}
                                >
                                    <SideNavigationPanel />
                                </Grid>
                                <Grid
                                    item
                                    className={globalStyles.appOutletMainWrapper}
                                    sx={{
                                        flexGrow: 1,
                                        display: 'flex',
                                        flexDirection: 'column',
                                        backgroundColor: 'transparent',
                                        overflow: 'hidden', // Prevent this container from scrolling
                                        height: '100%',
                                    }}
                                >
                                    {/* Sticky Navbar */}
                                    {navbarConfig && (
                                        <div style={{
                                            position: 'sticky',
                                            top: 0,
                                            zIndex: 100,
                                            backgroundColor: '#fff' // Add background to prevent content showing through
                                        }}>
                                            <GlobalNavbar
                                                navbarBtnText={navbarConfig.navbarBtnText}
                                                navbarText={navbarConfig.navbarText}
                                                navbarBtnOnClick={navbarConfig.navbarBtnOnClick}
                                                flagBorderBottom={navbarConfig.flagBorderBottom}
                                            />
                                        </div>
                                    )}

                                    {/* Scrollable Outlet */}
                                    <div className={globalStyles.outletSubWrapper}>
                                        <Outlet />
                                    </div>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
                <Grid
                    item
                    xs={12}
                    sx={{
                        position: isBelow768 ? "fixed" : "static",
                        width: "100%",
                        bottom: isBelow768 ? "0 !important" : "auto",
                        zIndex: "10"
                    }}
                >
                    <GLobalFooter />
                </Grid>
            </Grid>
        </>
    );
};

export default MainComponent;